<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{ newUser._id ? "Edit" : "New" }} User</h4>
  <button type="button" class="btn-close" aria-label="Close" (click)="onClose()"></button>
</div>
<div class="modal-body">
  <form #userForm="ngForm">
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-4">
          <div class="form-group">
            <label class="required">Name</label>
            <input type="text" class="form-control" name="name" [pattern]="pattern.Name"
              #personName="ngModel" [(ngModel)]="newUser.username" required>
          </div>
          @if (personName.touched && personName.invalid) {
            <div class="text-danger">
              {{ personName.errors?.['pattern'] ? "Name should not contains numbers or special characters" :
              "Please enter the name" }}
            </div>
          }
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label class="required">Email Id</label>
            <input type="text" [disabled]="newUser._id" #email="ngModel" class="form-control" name="emailId"
              [(ngModel)]="newUser.email" [pattern]="pattern.email" required>
          </div>
          @if (email.touched && email.invalid) {
            <div class="text-danger">
              {{ email.errors?.['pattern'] ? "Please enter a valid email format" : "Please enter your
              email address." }}
            </div>
          }
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <label>Mobile No</label>
            <input type="text" #mobile="ngModel" class="form-control" name="mobileNo"
              [(ngModel)]="newUser.phone" >
          </div>
          @if (mobile.touched && mobile.invalid) {
            <div class="text-danger">
              {{ mobile.errors?.['pattern'] ? "Mobile number must be 10 digits" : "Please enter your
              mobile number." }}
            </div>
          }
        </div>
        @if (!newUser._id) {
          <div class="col-md-4 mt-3">
            <div class="form-group">
              <label class="required">Password</label>
              <input type="text" #pswrd="ngModel" class="form-control" name="pwd"
                [(ngModel)]="newUser.password" required>
            </div>
            @if (pswrd.touched && pswrd.invalid) {
              <div class="text-danger">
                Please enter the password.
              </div>
            }
          </div>
        }
        <div class="col-md-4 mt-3">
          <div class="form-group">
            <label class="required">Role</label>
            <select class="form-control form-select" #usrRole="ngModel" name="rol"
              [(ngModel)]="newUser.role" required>
              <option value="Admin">Admin</option>
              <option value="Manager">Manager</option>
              <option value="Staff">Staff</option>
            </select>
          </div>
          @if (usrRole.touched && usrRole.invalid) {
            <div class="text-danger">
              Please select the role
            </div>
          }
        </div>
        <div class="col-md-4 mt-3">
          <div class="form-group">
            <label class="required">Status</label>
            <select class="form-control form-select" #status="ngModel" name="status"
              [(ngModel)]="newUser.status" required>
              <option value="Active">Active</option>
              <option value="InActive">In-Active</option>
            </select>
          </div>
          @if (status.touched && status.invalid) {
            <div class="text-danger">
              Please select status
            </div>
          }
        </div>
      </div>
      <div class="row">
        <div class="col-md-12 mt-4 text-center">
          <button [disabled]="!userForm.valid" class="btn btn-primary active mt-4 w-50"
          (click)="onSubmit()">Submit</button>
        </div>
      </div>
    </div>
  </form>
</div>